import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {MatCalendar, MatCalendarCellCssClasses} from "@angular/material/datepicker";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-select-date',
    templateUrl: './select-date.component.html',
    styleUrls: ['./select-date.component.scss'],
    standalone: false
})
export class SelectDateComponent implements OnInit {
    deltaDate = 7;
    maxDate: Date;
    dateForm: UntypedFormGroup;
    showCalendar: boolean = true;
    @ViewChild(MatCalendar, {static: false}) calendar: MatCalendar<Date> | undefined;
    disabled = false

    constructor(public dialogRef: MatDialogRef<SelectDateComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    title: string,
                    maxDate: Date,
                    buttons: { action: any, icon: string, color: string,text:string }[]|undefined
                }) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        this.maxDate = today;
        const beforSevenDay = new Date();
        const deltaDate = this.deltaDate ? this.deltaDate : 7;
        beforSevenDay.setDate(today.getDate() - deltaDate);
        this.dateForm = new UntypedFormGroup({
            start: new UntypedFormControl({value: beforSevenDay, disabled: false}),
            end: new UntypedFormControl({value: today, disabled: false}),
        });
    }

    ngOnInit(): void {
        if (this.data.maxDate != null) {
            this.maxDate = this.data.maxDate
        }
    }

    get startDate() {
        return this.dateForm.value.start
    }

    get endDate() {
        return this.dateForm.value.end
    }

    changeShowCalendarValue(value: boolean | undefined = undefined) {
        this.showCalendar = value != null ? value : !this.showCalendar
    }

    selectDate(event: Date | undefined | null) {

        if (event != null) {
            const start = this.dateForm.get('start')?.value;
            const end = this.dateForm.get('end')?.value;
            const setEndDate = start != null && end == null && this.isOverDate(event, start)
            if (setEndDate) {
                event.setHours(0, 0, 0, 0)
                this.dateForm.get('end')?.setValue(event);
                // this.changeCalendar.emit(this.dateForm.value)
            } else {
                event.setHours(0, 0, 0, 0)
                this.dateForm.get('start')?.setValue(event);
                this.dateForm.get('end')?.reset(null, {emitEvent: false});
            }
            this.updateCalendar();
        }


    }

    isEqualsDate(date1: Date, date2: Date) {
        return date2 != null && date1 != null && date1.getDate() == date2.getDate() &&
            date1.getMonth() == date2.getMonth() &&
            date1.getFullYear() == date2.getFullYear();
    }

    isOverDate(date1: Date, date2: Date) {
        return date2 != null && date1 != null && date1.getTime() >= date2.getTime()
    }

    dateClass = (d: Date): MatCalendarCellCssClasses => {
        const init: Date = new Date(this.startDate);
        const end: Date = new Date(this.endDate);
        const isBetween = (init: Date, x: Date, end: Date) => {
            if (init != null && end != null) {
                init.setHours(0, 0, 0, 0);
                end.setHours(0, 0, 0, 0);
                return init.getTime() < x.getTime() && x.getTime() < end.getTime()
            } else {
                return false;
            }
        }

        if (isBetween(init, d, end)) {
            return 'example-custom-date-class-preview'
        } else if (this.isEqualsDate(d, init) || this.isEqualsDate(d, end)) {
            return 'example-custom-date-class'
        } else {
            return ''
        }
    }

    updateCalendar() {
        if (this.calendar) {
            this.calendar.updateTodaysDate();
        }
    }

    closeDialog() {
        this.dialogRef.close(this.dateForm.value)
    }

    closeDialogButtons(action: any) {
        this.dialogRef.close({...this.dateForm.value, action})
    }

}
